module.exports = __webpack_public_path__ + "static/media/ic_navigation_single_arrow_left.9f361154.svg";